import InterfaceKonsul from "../apiInterface/InterfaceKonsul";
import { join, values, mapValues } from "lodash";
import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

class DataKonsul {
  async getDataKonsul(reg) {
    let dt: any;
    await InterfaceKonsul.getKonsul(reg)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Pasien Konsul");
      });
    return dt;
  }

  async getDataKonsulByID(id) {
    let dt: any;
    await InterfaceKonsul.getKonsulByID(id)
      .then(response => {
        dt = response.data;
      })
      .catch(e => {
        // console.log(e);
        dt = e.response;
        ErrorAlert.showSnackAlert(e, "Pasien Konsul");
      });
    return dt;
  }

  async saveDataKonsul(
    reg,
    cm,
    unit_pengirim_id,
    unit_tujuan_id,
    dr_pengirim_id,
    dr_tujuan_id,
    diag,
    masalah,
    konsultasi
  ) {
    let dt: object = {};
    await InterfaceKonsul.saveKonsul(
      reg,
      cm,
      unit_pengirim_id,
      unit_tujuan_id,
      dr_pengirim_id,
      dr_tujuan_id,
      diag,
      masalah,
      konsultasi
    )
      .then(response => {
        dt = response;
        // console.log(dt)
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async changeDataKonsul(
    id,
    reg,
    cm,
    unit_pengirim_id,
    unit_tujuan_id,
    dr_pengirim_id,
    dr_tujuan_id,
    diag,
    masalah,
    konsultasi
  ) {
    let dt: object = {};
    await InterfaceKonsul.changeKonsul(
      id,
      reg,
      cm,
      unit_pengirim_id,
      unit_tujuan_id,
      dr_pengirim_id,
      dr_tujuan_id,
      diag,
      masalah,
      konsultasi
    )
      .then(response => {
        dt = response;
        // console.log(dt)
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async saveDataJawabKonsul(
    surat_konsul_id,
    dr_konsulan_id,
    soap_id,
    note,
    reg,
    cm,
    unitId,
    s,
    o,
    a,
    p
  ) {
    let dt: object = {};
    await InterfaceKonsul.saveJawabKonsul(
      surat_konsul_id,
      dr_konsulan_id,
      soap_id,
      note,
      reg,
      cm,
      unitId,
      s,
      o,
      a,
      p
    )
      .then(response => {
        dt = response;
        // console.log(dt)
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async changeDataJawabKonsul(
    surat_konsul_id,
    dr_konsulan_id,
    soap_id,
    note,
    reg,
    cm,
    unitId,
    s,
    o,
    a,
    p
  ) {
    let dt: object = {};
    await InterfaceKonsul.changeJawabKonsul(
      surat_konsul_id,
      dr_konsulan_id,
      soap_id,
      note,
      reg,
      cm,
      unitId,
      s,
      o,
      a,
      p
    )
      .then(response => {
        dt = response;
        // console.log(dt)
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
        // let message = "";
        // if (dt['status'] == 422) {
        //   message = join(
        //     values(
        //       mapValues(e.response.data.errors, function (val) {
        //         return join(val, "; ");
        //       })
        //     ),
        //     "; "
        //   );
        //   dt = { status: 0, err: "ERR 422 : " + e.response.data.message + " (" + message + ")" }
        //   // dt = { status: 0, err: "ERR 422 : " + e.response.data.message }
        // } else {
        //   dt = { data: dt, status: dt['status'], err: "ERR " + e.response.status + " : " + e.response.data.message }
        // }
      });
    return dt;
  }

  async batalDataKonsul(id, alasan) {
    let dt: object = {};
    await InterfaceKonsul.batalKonsul(id, alasan)
      .then(response => {
        dt = response;
      })
      .catch(e => {
        dt = e.response;
        ErrorAlert.showErrorAlert(e);
      });
    return dt;
  }

  async terimaKonsul(id, unitPenerimaId, dokterPenerimaId, bypassCode = null) {
    const response = await http
      .putData(`/surat-konsul/${id}/terima`, {
        unit_penerima_id: unitPenerimaId,
        dokter_penerima_id: dokterPenerimaId,
        bypass_code: bypassCode,
      })
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }

  async cancelTerimaKonsul(id) {
    const response = await http
      .deleteData(`/surat-konsul/${id}/cancel-terima`)
      .catch(err => {
        ErrorAlert.showErrorAlert(err);

        return Promise.reject(err);
      });

    return response.data;
  }
}

export default new DataKonsul();
